import { useChangePassword as useChangePasswordAPI } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import { noticeError } from "src/utils"

export function useChangePassword() {
  const changePassword = useChangePasswordAPI()

  return useCallback(
    async (currentPassword: string, newPassword: string) => {
      try {
        if (!changePassword) {
          throw new Error("cannot update password for unauthenticated user")
        }

        const response = await changePassword(
          currentPassword,
          newPassword,
        )

        return response
      } catch (e) {
        noticeError(
          e,
          "ChangePassword",
        )

        throw e
      }
    },
    [changePassword],
  )
}
